import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { LockIcon } from 'lucide-react';
import { useListingPageContext } from '../../ListingPageContext';

export const MetricCardEmptyState = () => {
  const { setIncludeIndigoData } = useListingPageContext();

  return (
    <Flex
      alignItems="center"
      height="100%"
      justifyContent="center"
      width="100%"
    >
      <Flex alignItems="center" direction="column" gap={2}>
        <Icon as={LockIcon} color="whiteAlpha.500" />
        <Text>Include Indigo Offer Data to view</Text>
        <Button size="xs" onClick={() => setIncludeIndigoData(true)}>
          Enable
        </Button>
      </Flex>
    </Flex>
  );
};
